import ChatService from '@/service/ChatServices.js'
import { AppBridge} from '@/assets/js/common.js'



export default {
  props: ['broadcastVodInfo'],

  data () {
    return {
      chatService: null,
      chatList: [],
      vodChatList: [],
      lang: this.$i18n.locale,

      gameConfirm: false,
      gameMode: false,
      gameChallange: false,
      game: {
        gameSysId: null,
        round: 0,
        curJoinCnt: 0,
        mcSelected: false,
        countSync: false,
        userSelected: 0,
        userSended: false,
        gameOver: false,
        gameOverVisible: false,
        finished: false,
        status: 0,
        limitCnt: 0,
        isFinals: 0,
        winner: {
          nickName: ''
        }
      },
      gameCount: 10,
      gameCountFunc: null,
      liveCoupon: {
        name: '',
        discountPolicy: 0,
        discountPolicyFigures: 0
      },
      stFunc: null
    }
  },

  watch: {
    vodInfo: {
      handler (nd, od) {
        if (od.broadcastSysId !== nd.broadcastSysId) {
          if (this.chatService !== null) {
            this.chatService._LeaveRoom()
            this.chatService = null
          }

          // 채팅녹화가 되어있지 않으면 아래쪽 실행 안함
          if (nd.isRecChat === 1) return false

          this.createChatService()
          this.soketInit()
        }
      }
    },

    game: {
      deep: true,
      handler (n) {
        if (n.mcSelected && !n.userSended && !this.gameCountFunc && !n.gameOver) {
          this.gameCounting()
        }
      }
    }
  },

  async created () {
    // 채팅녹화가 되어있지 않으면 아래쪽 실행 안함
    if (this.vodInfo.isRecChat === 1 && this.broadcastVodInfo.type === 'vod') return false

    this.createChatService()
  },

  mounted () {
    // 채팅녹화가 되어있지 않으면 아래쪽 실행 안함
    if (this.vodInfo.isRecChat === 1 && this.broadcastVodInfo.type === 'vod') return false

    this.soketInit()
  },

  beforeDestroy () {
    // 채팅서버 연결종료
    if (this.chatService === null) return false

    this.chatService._LeaveRoom()
    this.chatService = null
  },

  methods: {
    // 초기화
    soketInit () {
      this.chatService._Socket.on('joinRoom', data => {
        console.log(data)
        // 지난방송이 아닐 때만 입장 고정 실행
        this.roomInfo.likeCnt = data.room.likeCnt
        if (this.chatServiceOption.mode !== 'vod') {
          this.roomInfo.viewCnt = data.room.joinCnt
          if (data.room.noti !== null) {
            this.roomInfo.noti = data.room.noti
            this.notiVisible = true
          } else {
            this.roomInfo.noti = ''
          }
          if (data.room.fixPrdtSysId !== 0 && data.room.fixPrdtSysId !== null) {
            this.rollingFixPrdt = data.room.fixPrdtSysId
            this.rollingFix()
          } else {
            if (this.viewPrdtTo === null) {
              this.rollingPrdt()
            }
          }
    
          this.chatService._Socket.emit('chklive')
          this.chatService._Socket.on('chklive', data => {
            if (data.broadcast.liveFlag === 1) {
              console.log('live체크 : ', data)
              this.streaming(data.broadcast.liveFlag)
            }
          })
        }

        // 가위바위보 세팅
        if (data.game?.gameSysId && data.game?.status !== 5) {
          this.gameMode = true
          this.game.gameSysId = data.game.gameSysId
          this.game.status = data.game.status
          this.game.round = data.game.lastRound
          this.game.curJoinCnt = data.game.curJoinCnt
          this.game.limitCnt = data.game.limitJoinCnt
          this.game.isFinals = data.game.isFinals
          this.game.winner.nickName = data.game.winnerNick

          if (data.game.status === 0) { this.gameConfirm = true }
          if (data.game.status === 3) { this.game.mcSelected = true }
          if (data.game.status === 4) { this.gameWinnerFunc(data) }
        }
      })
  
      this.chatService._Socket.on('chatMessage', data => {
        // 일반 채팅
        if (data.message.msgType === 0) {
          this.printChat(data, 0)
  
        // 공지
        } else if (data.message.msgType === 3) {
          this.printChat(data, 3)
  
        // 홍보
        } else if (data.message.msgType === 4) {
          this.printChat(data, 4)
        }
      })
  
      this.chatService._Socket.on('questionAnswer', data => {
        this.printChat(data, 1)
      })
  
  
      this.chatService._Socket.on('event', data => {
        console.log(data)
        // 구매여기
        if (data.event.eventType === 1) {
          this.buyHereAni()
  
        // 공지사항 닫기
        } else if (data.event.eventType === 2) {
          this.closeNoti()
        }
      })
  
      
      // 채팅방 상품 노출
      this.chatService._Socket.on('viewPrdt', data => {
        this.popPrdt(data.prdt.prdtSysId)
      })
  
      // 상품 롤링 고정
      this.chatService._Socket.on('fixPrdt', data => {
        if (data.prdt.prdtSysId !== null) {
          this.rollingFixPrdt = data.prdt.prdtSysId
          this.rollingFix()
        }
      })
  
      // 블랙유저 이벤트
      this.chatService._Socket.on('regBlackUser', data => {
        console.log(data)
        if (data.black.blackType === 1) {
          let ids = data.black.userSysIds.split(',')
          if (ids.indexOf(sessionStorage.getItem('userSysId')) > -1) {
            alert( this.$t('broadcast.kick') )
            window.closePip()
          }
        } else if (data.black.blackType === 2) {
          let ids = data.black.userSysIds.split(',')
          if (ids.indexOf(sessionStorage.getItem('userSysId')) > -1) {
            alert( this.$t('broadcast.superKick') )
            window.closePip()
          }
        }
      })
  
      // 라이브 체크 이벤트
      this.chatService._Socket.on('broadcastControl', data => {
        console.log(data)
        this.streaming(data.broadcast.liveFlag)
      })
  
  
      // 좋아요 이벤트 수신
      this.chatService._Socket.on('like', async data => {
        if (data.room.room === this.broadcastVodInfo.bcScheduleSysId) {
          if (data.room.likeCnt > this.roomInfo.likeCnt) {
            this.roomInfo.likeCnt = data.room.likeCnt
  
            let box = this.$refs.heartBox
            let img = document.createElement('img')
            let no = Math.floor(Math.random() * 6)
            img.setAttribute('src', this.hearts[no])
            img.classList.add('ani'+no)
            box.appendChild(img)
  
            setTimeout(() => {
              box.removeChild(img)
            }, 2000)
          }
        }
      })


      // 다시보기 채팅 이벤트
      this.chatService._Socket.on('vodChatHist', async data => {
        console.log('vodChatHist: ', data)
        let chat = data.vod.arrChatHist

        if (this.lang !== 'ko') {
          // 번역
          const reqObj = {
            unique: ['createdAt', 'userId'],
            property: ['msg'],
            data: await new Promise(res => {
              const list = chat.filter(x => !!x.msg)
              res(list)
            })
          }

          if (reqObj.data.length > 0) {
            await window.TranslateService.trans(reqObj, chat)
          }
          // 번역

          chat.forEach(x => {
            this.vodChatList.push(x)
          })

        } else {
          chat.forEach(x => {
            this.vodChatList.push(x)
          })
        }

      })

      // 다시보기 고정값 이벤트 수신
      this.chatService._Socket.on('fixInfo', data => {
        console.log('fixInfo', data)

        if (data.room.fixPrdtSysId !== null) {
          this.rollingFixPrdt = data.room.fixPrdtSysId
          this.rollingFix()
        }

        if (data.room.noti !== null) {
          this.roomInfo.noti = data.room.noti
          this.notiVisible = true
        }
      })

      // 가위바위보 게임 - 생성 이벤트
      this.chatService._Socket.on('createGame', data => {
        console.log('createGame', data)

        if (this.stFunc) {
          clearTimeout(this.stFunc)
          this.stFunc = null
        }

        this.gameInit()
        this.game.gameSysId = data.game.gameSysId
        this.gameMode = true
        this.game.limitCnt = data.game.limitCnt

        if (sessionStorage.getItem('accessToken')) {
          this.gameConfirm = true
        }
      })

      // 가위바위보 게임 - 게임참여 이벤트
      this.chatService._Socket.on('joinGame', data => {
        console.log('joinGame', data)

        if (this.stFunc) {
          clearTimeout(this.stFunc)
          this.stFunc = null
        }

        const myUserSysId = Number(sessionStorage.getItem('userSysId'))

        this.game.curJoinCnt = data.game.curJoinCnt
        
        if ( data.user.userSysId === myUserSysId ) {
          if (data.res.resCode === '0001') {
            this.gameChallange = true
          } else {
            alert( this.$t('broadcast.failedJoinGame') )
          }
        }
      })

      // 가위바위보 게임 - 게임상태변경 이벤트
      this.chatService._Socket.on('modGame', data => {
        console.log('modGame', data)

        if (this.stFunc) {
          clearTimeout(this.stFunc)
          this.stFunc = null
        }

        this.game.curJoinCnt = data.game.curJoinCnt
        this.game.status = data.game.status
        this.game.round = data.game.lastRound
        this.game.mcSelected = false
        this.game.isFinals = data.game.isFinals

        this.gameCount = 10
        this.gameCountFunc = null

        if (this.game.status === 5) {
          this.gameInit()
        }
      })

      // 가위바위보 게임 - 가위바위보내기(셀러버) 이벤트
      this.chatService._Socket.on('chooseGameSellover', data => {
        console.log('chooseGameSellover', data)

        if (this.stFunc) {
          clearTimeout(this.stFunc)
          this.stFunc = null
        }

        this.game.curJoinCnt = data.game.curJoinCnt
        this.game.status = data.game.status
        this.game.mcSelected = true
        this.game.countSync = true
        this.gameCounting()
      })

      // 가위바위보 게임 - 가위바위보내기(회원) 이벤트
      this.chatService._Socket.on('chooseGameUser', data => {
        console.log('chooseGameUser', data)

        if (this.stFunc) {
          clearTimeout(this.stFunc)
          this.stFunc = null
        }

        this.game.userSended = true
        this.gameCount = 10
        this.gameCountFunc = null
        this.game.userSelected = 0
        if (data.res.resCode !== '0001') {
          this.game.gameOver = true
        }
        if (data.res.resCode === '0001' && data.game.resMatch === 1 && this.game.isFinals === 1) {
          this.gameChallange = false
        }
      })

      // 가위바위보 게임 - 게임결과 이벤트
      this.chatService._Socket.on('resultGame', data => {
        console.log('resultGame', data)

        if (this.stFunc) {
          clearTimeout(this.stFunc)
          this.stFunc = null
        }

        this.game.userSended = false
        this.game.curJoinCnt = data.game.curJoinCnt
        this.game.round = data.game.lastRound
        this.game.isFinals = data.game.isFinals
        this.game.mcSelected = false
        this.game.status = 1

        this.gameWinnerFunc(data)

      })

      // 라이브쿠폰 발급 이벤트
      this.chatService._Socket.on('liveCoupon', data => {
        console.log('liveCoupon', data)

        if (data.coupon.name !== '') {
          this.liveCoupon.name = data.coupon.name
          this.liveCoupon.discountPolicy = data.coupon.discountPolicy
          this.liveCoupon.discountPolicyFigures = data.coupon.discountPolicyFigures

          this.stFunc = setTimeout(() => {
            this.getCoupon()
          }, 5000)
        }
      })
    },


    // 랜딩페이지 설정 후, 로그인 이동
    goLogin () {
      sessionStorage.setItem('landingPage', `/Vod/${this.broadcastVodInfo.bcSysId}/${this.broadcastVodInfo.bcScheduleSysId}/live`)
      this.$router.replace('/Login')
    },


    createChatService () {
      if (this.chatService !== null && this.chatService._Socket.connected) {
        this.chatService._LeaveRoom()
        this.chatService = null
      }

      // 채팅 서비스 생성
      const chatOption = this.chatServiceOption

      if (sessionStorage.getItem('accessToken') && chatOption.mode !== 'vod' ) {
        chatOption.accessToken = sessionStorage.getItem('accessToken')
      }
      if (sessionStorage.getItem('nickName') && chatOption.mode !== 'vod') {
        chatOption.user.nickName = sessionStorage.getItem('nickName')
      }
      
      this.chatService = new ChatService(chatOption)
    },

    // 채팅창 함수
    printChat (data, type) {
      // console.log(data)
      let chatObj = {}
      if (type === 0 || type === 1) {
        // 일반,관리자 채팅
        if (type === 0) {
          chatObj = {
            nick: data.user.nickName,
            msg: data.message.msg,
            msgType: 0,
            userId: data.user.userId,
            permission: data.user.permission === 2 ? false : true
          }

        // 질문답변
        } else if(type === 1) {
          chatObj = {
            nick: data.question.nickName,
            userId: data.user.userId,
            content: data.question.content,
            answer: data.question.answer,
            msgType: 1,
            permission: false
          }
        }

        this.chatList.push(chatObj)
      } else if(type === 3) {
        this.roomInfo.noti = data.message.msg
        this.notiVisible = true
      } else if(type === 4) {
        this.roomMarketing = ''

        this.roomMarketing = data.message.msg
      }
    },

    // 채팅 전송 함수
    sendChat (chatObj) {
      this.chatService._SendChat(chatObj)
    },

    // 좋아요 버튼 동작
    likeAct () {
      if (!sessionStorage.getItem('accessToken')) {
        let conf = confirm( this.$t('broadcast.likeNeedLogin') )
        if (conf) {
          let vodInfo = {
            broadcastSysId: null,
            broadcastScheduleSysId: null,
            vodPlaying: false,
            pipMode: false,
            type: null,
            top:0,
            right:0
          }

          window.pastVod(vodInfo)
          AppBridge.send('VodPipExit', {'value': 'close'}, true)
          this.goLogin()

          return 
        }
        return false
      }

      this.chatService._like()
    },


    // 채팅방 상품노출 함수
    popPrdt (prdtSysId) {
      this.fixPrdtSysId = prdtSysId
        setTimeout(() => {
          this.fixPrdtVisible = true
        }, 0)
  
        setTimeout(() => {
          this.fixPrdtVisible = false
          setTimeout(() => {
            this.fixPrdtSysId = null
          }, 1000)
        }, 6000)
    },


    // 가위바위보 게임
    game_confirm (value) {
      this.gameConfirm = false

      if (value) {
        this.chatService._JoinGame(this.game.gameSysId)
      }
    },

    userSelect (num) {
      if (this.game.mcSelected && !this.game.userSended) {
        this.game.userSelected = num
      }
    },

    gameCounting () {
      this.gameCountFunc = setTimeout(() => {
        if (this.gameCountFunc) { clearTimeout(this.gameCountFunc) }
        this.gameCount--

        if (this.gameCount <= 0) {
          if (this.gameChallange) { this.chatService._ChooseGameUser({ gameSysId: this.game.gameSysId, choose: this.game.userSelected }) }
        } else {
          this.gameCounting()
        }
      }, 1000)
    },

    exitGameMode () {
      this.gameInit()
    },

    gameOver () {
      this.gameChallange = false
      this.game.gameOver = false
      this.game.gameOverVisible = false
    },

    gameInit () {
      this.gameConfirm = false
      this.gameMode = false
      this.gameChallange = false
      this.game.gameSysId = null
      this.game.round = 0
      this.game.curJoinCnt = 0
      this.game.mcSelected = false
      this.game.countSync = false
      this.game.userSelected = 0
      this.game.userSended = false
      this.game.gameOver = false
      this.game.gameOverVisible = false
      this.game.finished = false
      this.game.status = 0
      this.game.limitCnt = 0
      this.game.isFinals = 0
      this.gameCount = 10
      this.gameCountFunc = null
    },

    gameWinnerFunc (data) {
      if (this.game.gameOver) {
        this.game.gameOverVisible = true

        return this.stFunc = setTimeout(() => {
          this.game.gameOver = false
          this.game.gameOverVisible = false
          this.gameChallange = false

          if (data.game.winnerNick) { this.printWinner(data.game.winnerNick, 3)}
          if (data.game.curJoinCnt === 0) { this.printWinner( this.$t('global.sellover') , 3) }
        }, 4000)
      }

      if (data.game.winnerNick) { this.printWinner(data.game.winnerNick, 6)}
      if (data.game.curJoinCnt === 0) { this.printWinner( this.$t('global.sellover') , 6) }
    },

    printWinner (nick, sec) {
      this.game.finished = true
      this.game.winner.nickName = nick

      this.stFunc = setTimeout(() => {
        this.gameInit()
      }, sec * 1000)
    },

    getCoupon () {
      this.liveCoupon.name = ''
      this.liveCoupon.discountPolicy = 0
      this.liveCoupon.discountPolicyFigures = 0
    }
    
  },
  
}